import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player";

import DataService from "../services/dataService";
import SettingsService from "../services/settingsService";
import TranslationFilterService from "../services/translationFilterService";

import "../styles/player.css";

const FPS = 4;
const FRONTRUNSEGMENTS = 1;

export default function PlayerComponent(props) {
  const [translation, setTranslation] = useState("");
  const [settings, setSettings] = useState(SettingsService.getSettings());

  const playerConfig = {
    youtube: {
      playerVars: {
        cc_load_policy: 1,
        controls: 1,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        rel: 0,
        start: settings["skipIntro"] ? 76 : 0,
      },
    },
  };

  useEffect(() => {
    const subscription = SettingsService.onSettings().subscribe((settings) =>
      setSettings(settings)
    );
    return subscription.unsubscribe;
  }, []);

  useEffect(() => {
    DataService.clearTranslations();
    setTranslation("");
  }, [props.videoId]);

  const onProgress = (progressData) => {
    const roundedTime = Math.ceil(FPS * progressData["playedSeconds"]) / FPS;
    const playerProgress = {
      videoId: props.videoId,
      seconds: adjustedTimeWithFrontRunning(roundedTime),
    };
    updateTranslation(playerProgress);
  };

  const adjustedTimeWithFrontRunning = (time) => {
    const frontRunAddition = (1 / FPS) * FRONTRUNSEGMENTS;
    return time + frontRunAddition;
  };

  const updateTranslation = (playerProgress) => {
    const incomingTranslation = DataService.getTranslation(playerProgress);
    if (incomingTranslation !== translation) {
      let filteredTranslation = TranslationFilterService.filterTranslation(
        incomingTranslation,
        playerProgress
      );
      setTranslation(filteredTranslation);
    }
  };

  return (
    <>
      <div className="player-container">
        <ReactPlayer
          url={"https://www.youtube.com/watch?v=" + props.videoId}
          className="player-react-player"
          progressInterval={200}
          onProgress={onProgress}
          config={playerConfig}
        />
      </div>
      <div
        className={`player-translations ${
          settings["above"]
            ? "player-translations-above"
            : "player-translations-below"
        } ${
          settings["background"] && translation
            ? "player-translations-dark-background"
            : ""
        }`}
      >
        <p>&nbsp;{translation}&nbsp;</p>
      </div>
    </>
  );
}
